import { render } from "./ItemPersons.vue?vue&type=template&id=fe63bb06"
import script from "./ItemPersons.vue?vue&type=script&lang=js"
export * from "./ItemPersons.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\zoodkomak_tv_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__